export default () => {

    let Now = new Date();
    // var Now = new Date("May 21, 2022 8:15:00"); // For test

    const startingHour = {
        1: 9,
        2: 9,
        3: 9,
        4: 9,
        5: 9,
        6: 9,
        0: 9
    };
    const closingHour = {
        1: 17,
        2: 17,
        3: 17,
        4: 17,
        5: 17,
        6: 17,
        0: 17
    };

    const CurrentDay = Now.getDay();
    let openingTime = new Date(Now.getFullYear(), Now.getMonth(), Now.getDate(), startingHour[CurrentDay]);
    let closingTime = new Date(Now.getFullYear(), Now.getMonth(), Now.getDate(), closingHour[CurrentDay]);
    const Open = (Now.getTime() > openingTime.getTime() && Now.getTime() < closingTime.getTime());

    // days 0.sun 1.mon 2.tues 3.wed 4.thur 5.fri 6.sat
    // if I want to be closed on Sat and Sun use condition
    // CurrentDay !== 6 && CurrentDay !== 0 && Open
    if (!(CurrentDay !== 6 && CurrentDay !== 0 && Open)) {
        document.getElementsByTagName("BODY")[0].classList.toggle('js-support-offline');
    }

}
